<template>
    <div>
        <v-card>
            <s-toolbar label="Reporte de Distribución" dark color="#8e8f91" excel @excel="downloadExcel()">
                <div style="display: flex; justify-content: space-between">
                    <div style="display: flex;">
                        <div>
                            <v-text-field style="margin-top:-1px; width:150px !important;" ref="buscar" height="30"
                                width="60" v-model="textSearch" dense clearable hide-details @keyup.enter="clickSearch()"/>
                        </div>
                        <v-tooltip bottom="">
                            <template v-slot:activator="{ on }">
                                <v-btn :color="'white'" text v-on="on" small @click="clickSearch()"> <v-icon> mdi-magnify</v-icon></v-btn>
                            </template>
                            <span>Buscar</span>
                        </v-tooltip>
                    </div>
                </div>
            </s-toolbar>
            <v-container>
				<v-row>
                    <v-col cols="12" md="3">
                        <s-select-campaign-se 
                            label="Campaña"
                            v-model="filter.CmpID"
                            clearable
                        />
                    </v-col>
                    <v-col cols="12" md="3">
                        <s-select-definition 
                            :def="1060" 
                            label="Planilla" 
                            v-model="filter.TypePayrollsValue" 
                            multiple
                            clearable
                        />
                    </v-col>
                    <v-col cols="12" md="3">
                        <s-select-area
                            label="Área"
                            v-model="filter.AreIDs"
                            multiple
                            clearable
                        >
                        </s-select-area>
                    </v-col>
                    <v-col cols="12" md="3">
                        <s-select-definition
                            :def="1278"
                            label="Turno"
                            v-model="filter.TypeTurn"
                            clearable
                        />
                    </v-col>
                    <v-col cols="12" md="2">
                        <s-date
                            :key="dateKey"
                            label="Fecha Inicio"
                            v-model="filter.InitDate"
                        />
                    </v-col>
                    <v-col cols="12" md="2">
                        <s-date
                            label="Fecha Fin"
                            v-model="filter.EndDate"
                            disabled
                        />
                    </v-col>
                    <v-col cols="12" md="3">
                        <s-toolbar-person 
                            label="Buscar Persona" 
                            v-model="PrsDocumentNumber" 
                            noCamera 
                            noEdit 
                            @returnPerson="returnPerson($event)"
                        />
                    </v-col>
                    <v-col cols="12" md="4">
                        <div class="d-flex align-center">
                            <s-text v-model="NtpFullName" label="Apellidos y Nombres" readonly class="flex-grow-1"/>
                            <v-btn icon x-small color="dark" @click="clearPerson()" class="ml-2 mt-3">
                                <v-icon>mdi-broom</v-icon>
                            </v-btn>
                        </div>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-data-table
                            item-key="Line"
                            dense
                            fixed-header
                            :items="items"
                            :headers="headers"
                            :items-per-page="10"
                            v-model="selected"
                            :loading="loading"
                        ></v-data-table>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
    </div>
</template>

<script>
    import _sHmnHoursWorkedService from '@/services/HumanResource/HmnHoursWorkedService.js';
    import sToolbarPerson from "@/components/Utils/Person/sToolbarPerson";
    import _WorkService from "@/services/HumanResource/WorkerService";

    export default {
        components: {
            sToolbarPerson
        },
        data() {
            return {
                filter:{
                    CmpID: 0,
                    TypeTurn: 0,
                    TypeReport: 2,
                    WkrID: 0
                },
                NtpFullName: "",
                PrsDocumentNumber: "",
                NtpID: 0,
                PrsID: 0,
                WkrID: 0,
                item: null,
                selected: [],
                items: [],
                headers: [],
                loading: false,
                debounceTimer: null,
                dateKey: 0,
                textSearch: '',
            }
        },
        methods:{
            returnObject(item) {
                this.item = item;
            },
            async returnPerson(event) {
                if(event){
                    this.NtpFullName = event.NtpFullName;
                    this.PrsDocumentNumber = event.PrsDocumentNumber;
                    this.NtpID = event.NtpID;
                    this.PrsID = event.PrsID;
                    this.WkrID = event.WkrID;

                    try {
                        const detailResponse = await _WorkService.DetailByNtpID(event.NtpID, this.$fun.getUserID());
                        this.WkrID = detailResponse.data.WkrID;
                        // Now load data after setting WkrID
                        this.debouncedLoad();
                    } catch (error) {
                        console.error("Error cargando datos del trabajador:", error);
                    }
                }
            },
            debouncedLoad() {
                // Clear any existing timer
                clearTimeout(this.debounceTimer);
                
                // Set a new timer
                this.debounceTimer = setTimeout(() => {
                    this.load();
                }, 300); // 300ms debounce time
            },
            load() {
                console.log("ingresando a la funcion load()");
                this.filter.WkrID = this.WkrID;
                // Set loading state
                this.loading = true;

                let TypePayrolls = "";
                try {
                    const parsed = JSON.parse(this.filter.TypePayrollsValue);
                    if (Array.isArray(parsed)) {
                        this.filter.TypePayrollsValue = parsed.join(',');
                        TypePayrolls = this.filter.TypePayrollsValue;
                        console.log("TypePayrolls", this.filter.TypePayrollsValue);
                    }
                } catch (e) {
                    TypePayrolls = this.filter.TypePayrollsValue;
                }

                this.filter.TypePayrolls = TypePayrolls;

                _sHmnHoursWorkedService.list(this.filter, this.$fun.getUserID())
                    .then(r => {
                        console.log("r.data", r.data);
                        const data = r.data;

                        if (Array.isArray(data) && data.length > 0) {
                            // Generar headers dinámicamente
                            this.headers = Object.keys(data[0]).map(key => ({
                                text: key.replace(/_/g, ' ').toUpperCase(),
                                value: key
                            }));
                        } else {
                            this.headers = [];
                        }
                        
                        this.items = data;
                    })
                    .catch(error => {
                        console.error("Error al cargar datos:", error);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
            clearPerson() {
                this.NtpFullName = "";
                this.PrsDocumentNumber = "";
                this.NtpID = 0;
                this.PrsID = 0;
                this.WkrID = 0;
                this.debouncedLoad();
            },
            downloadExcel() {
                _sHmnHoursWorkedService.excel(this.filter, this.$fun.getUserID())
                    .then(r => {
                        console.log("r.data", r.data);
                        this.$fun.downloadFile(r.data, this.$const.TypeFile.EXCEL, 'Reporte_Distribucion');
                    });
            },
            clickSearch() {
                this.debouncedLoad();
            }
        },
        watch: {
            'filter.InitDate'(newVal) {
                if (newVal) {
                    let selected = this.$moment(newVal, this.$const.FormatDateDB);
                    let dayOfWeek = selected.day();
                    let monday = selected.clone().subtract(dayOfWeek === 0 ? 6 : dayOfWeek - 1, 'days');
                    let sunday = monday.clone().add(6, 'days');

                    // Asigna fechas corregidas
                    this.filter.InitDate = monday.format(this.$const.FormatDateDB);
                    this.filter.EndDate = sunday.format(this.$const.FormatDateDB);

                    // Fuerza la recarga visual del componente
                    this.dateKey++;
                }
            },
            // Use deep watcher for filter object
            // filter: {
            //     handler() {
            //         this.debouncedLoad();
            //     },
            //     deep: true
            // }
        },
        mounted() {
            // Initial load
            //this.debouncedLoad();
        }
    }
</script>